export default __webpack_public_path__ + "static/media/Banner - Hybridshell - Cobalt Blue.806ee736.jpg";